import type * as Api from 'Api'

export const orderKitErrorHandbook: Api.ErrorsHandbook<'default'> = {
  default: [],
}
